import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowTopRightIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 7.18969L0.81106 8L6.87189 1.94475L6.87189 6.6151L8 6.60774L8 0.00736588L1.38618 0L1.39355 1.1418L6.06083 1.13444L0 7.18969Z"
      fill={fill}
    />
  </svg>
);

export default ArrowTopRightIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowTopRightIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 7.18969L0.81106 8L6.87189 1.94475L6.87189 6.6151L8 6.60774L8 0.00736588L1.38618 0L1.39355 1.1418L6.06083 1.13444L0 7.18969Z"
      fill={fill}
    />
  </svg>
);

export default ArrowTopRightIcon;
